import type { ResolverConstructor } from 'customer-flows/utils/quote/resolvers'
import tickets from './tickets'
import availability from './availability'
import customer from './customer'
import activity from './activity'
import questionAnswers from './question-answers'
import source from './source'
import channel from './channel'

export const fieldResolverRegistry = {
  ...tickets,
  ...availability,
  ...customer,
  ...activity,
  ...questionAnswers,
  ...source,
  ...channel
} satisfies Record<string, ResolverConstructor<any>>
